import { groupOfStem } from '../lib/engine.js';
import { GROUP_LABEL } from '../lib/rules.js';

// 대운(10년 단위 운의 흐름) 흐름도. saju: 서버 응답, age: 현재 나이
const STEM_KO = ['갑', '을', '병', '정', '무', '기', '경', '신', '임', '계'];
const BRANCH_KO = ['자', '축', '인', '묘', '진', '사', '오', '미', '신', '유', '술', '해'];
const GROUP_COLOR = { 비겁: '#5aa86a', 식상: '#e0574a', 재성: '#c9a227', 관성: '#8a8f9a', 인성: '#3f6db5' };

export default function DaewoonFlow({ saju, age, birthYear, scene = '' }) {
  const list = saju.daewoon.list;
  const ds = saju.day.stem;
  const first = Math.round(list[0].age);
  const cycles = list.map((d) => {
    const start = Math.round(d.age);
    return { start, end: start + 9, d, group: groupOfStem(ds, d.stem) };
  });
  const current = cycles.findIndex((c) => age >= c.start && age <= c.end);
  const pre = age < first;

  return (
    <section className="panel flow">
      <h3>대운 흐름 <small className="muted">(10년마다 바뀌는 운 · {saju.daewoon.forward ? '순행' : '역행'})</small></h3>
      {scene && <p className="luck-scene" role="status">{scene}</p>}
      <div className="flowrow">
        <div className={`cyc ${pre ? 'now' : ''}`}>
          <div className="cage">{first - 1 <= 0 ? 0 : `0–${first - 1}`}세</div>
          <div className="cname">대운 전</div>
          {pre && <div className="here">▲ 지금 {age}세</div>}
        </div>
        {cycles.map((c, i) => (
          <div key={c.start} className={`cyc ${i === current ? 'now' : ''} ${i < current ? 'past' : ''}`}>
            <div className="cage">{c.start}–{c.end}세</div>
            <div className="cko">{STEM_KO[c.d.stem]}{BRANCH_KO[c.d.branch]}</div>
            <div className="copen" style={{ background: GROUP_COLOR[c.group] }}>{GROUP_LABEL[c.group]}</div>
            {i === current && <div className="here">▲ 지금 {age}세</div>}
          </div>
        ))}
      </div>
      <h3 className="seun-h">세운 <small className="muted">(해마다 바뀌는 운)</small></h3>
      <div className="flowrow">
        {Array.from({ length: 10 }, (_, i) => age - 2 + i).filter((a) => a >= 0).map((a) => {
          const y = birthYear + a;
          const st = (((y - 4) % 10) + 10) % 10, br = (((y - 4) % 12) + 12) % 12;
          const g = groupOfStem(ds, st);
          return (
            <div key={a} className={`cyc ${a === age ? 'now' : ''} ${a < age ? 'past' : ''}`}>
              <div className="cage">{a}세 · {y}</div>
              <div className="cko">{STEM_KO[st]}{BRANCH_KO[br]}</div>
              <div className="copen" style={{ background: GROUP_COLOR[g] }}>{GROUP_LABEL[g]}</div>
            </div>
          );
        })}
      </div>
      <p className="muted small">각 대운이 열어 주는 영역이에요. 기회는 그 영역에서 행동할 때만 결과로 이어져요.</p>
    </section>
  );
}
